import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate, FormattedMessage, FormattedTime} from "react-intl";
import {generateUrl, routes} from "helpers/routes";
import {Link} from "react-router-dom";
import RelativeDuration from "components/RelativeDuration";
import moment from 'moment';
import IconSvg from "components/IconSvg";
import {formatPhone} from "helpers/phone";

class Conversation extends React.Component {
    static propTypes = {
        conversation: PropTypes.shape({
            id: PropTypes.number.isRequired,
            advert: PropTypes.shape({
                id: PropTypes.number.isRequired
            }).isRequired,
            title: PropTypes.string.isRequired,
            customer: PropTypes.shape({
                id: PropTypes.number.isRequired,
            }).isRequired,
            numUnread: PropTypes.number.isRequired,
            hasBeenAnswered: PropTypes.bool,
            contacts: PropTypes.arrayOf(PropTypes.shape({
                id: PropTypes.number.isRequired,
                customerPhonenum: PropTypes.string.isRequired,
                type: PropTypes.oneOf(['voice', 'text']).isRequired,
                timeCreated: PropTypes.number.isRequired,
                directionReceived: PropTypes.bool,
                text: PropTypes.shape({
                    message: PropTypes.string.isRequired,
                }),
                voice: PropTypes.shape({
                    state: PropTypes.oneOf(['RINGING', 'UP', 'MISSED', 'FINISHED', 'CREATED']).isRequired,
                    timeStarted: PropTypes.number,
                    note: PropTypes.string,
                }),
            })).isRequired,
        }).isRequired,
        selected: PropTypes.bool,
    };

    render() {
        const {conversation, selected} = this.props;
        const contact = conversation.contacts[0];
        const phone = contact ? contact.customerPhonenum : '';

        let classes = "call__item ";
        classes += selected ? 'call__item--selected ' : '';

        const isVoice = contact && contact.type === 'voice';
        const active = contact && isVoice && ['UP', 'RINGING'].includes(contact.voice.state);
        const ringing = contact && active && contact.voice.state === 'RINGING';
        const target = generateUrl(routes.conversations, {
            customer: conversation.customer.id,
            profile: conversation.id,
            advert: conversation.advert.id,
        }, {view: 'conversation'});

        let status;
        if (active) {
            classes += 'call__item--active';
            status = 'active';
        }
        else if (conversation.numUnread > 0) {
            classes += 'call__item--unread';
            status = 'unread';
        }
        else if (contact && contact.directionReceived) {
            classes += 'call__item--read';
            status = 'read';
        }
        else if (contact) {
            classes += 'call__item--resolved';
            status = 'resolved';
        }

        const text = (contact && (isVoice ? contact.voice.note : contact.text.message)) || '';

        return (
            <div>
                <Link to={target} className={classes}>
                    <div className="call__id">
                        <h3 className="call__title">
                            {active &&
                            <FormattedMessage id="conversation.active_call" defaultMessage="Active call"/>
                            }

                            {!active &&
                            <span>{conversation.title} {formatPhone(phone)}</span>
                            }
                        </h3>
                        <div className="call__content">
                            <span className="call__content--icon">
                                {status === 'resolved' &&
                                <IconSvg id='status-past'/>
                                }
                            </span>
                            {active &&
                            <span>{conversation.title} {formatPhone(phone)}</span>
                            }

                            {!active && text !== '' &&
                            <span>{text}</span>
                            }

                            {!active && text === '' &&
                            <span>&nbsp;</span>
                            }
                        </div>
                    </div>
                    <div className="call__meta">
                        {active &&
                        <IconSvg id="phone"/>
                        }

                        {active && ringing &&
                        <FormattedMessage id="conversation.ringing" defaultMessage="Ringing"/>
                        }

                        {active && !ringing &&
                        <RelativeDuration date={moment.unix(contact.voice.timeStarted)}/>
                        }

                        {!active && contact &&
                        <span>
                            <FormattedDate value={moment.unix(contact.timeCreated)}/> <FormattedTime
                            value={moment.unix(contact.timeCreated)}/>
                        </span>
                        }
                    </div>
                </Link>
            </div>
        )
    }
}

export default Conversation;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Controls/Conversation.jsx